import React from 'react';
import { useAdminData } from '../useAdminData';
import BooksEditor from '../editors/BooksEditor';

const BooksPage = () => {
    const { formData, isLoading, isSaving, error, success, handleFormChange, handleSave } = useAdminData();

    if (isLoading) return <div>Betöltés...</div>;
    if (!formData) return <div>{error || "Hiba az adatok betöltésekor."}</div>;

    return (
        <div>
            <div className="admin-page-header">
                <h1>Könyvek Kezelése</h1>
                <div>
                    {success && <span className="success-message">{success}</span>}
                    <button onClick={() => handleSave(null)} className="save-button" disabled={isSaving}>
                        {isSaving ? 'Mentés...' : 'Mentés'}
                    </button>
                </div>
            </div>
            <div className="editor-card">
                <BooksEditor books={formData.books} feedbacks={formData.feedbacks || []}  onFormChange={handleFormChange} />
            </div>
        </div>
    );
};

export default BooksPage;